module.exports = __webpack_public_path__ + "img/blocks-1.f3280ee4.png";